import React, { useState } from "react";
import { FormGroup, Button, Label, Input, Container } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { CreateBathroomType } from "../../apis/BathroomType";
import { AxiosError } from "axios";

const AddBathroomType = () => {
  const [isChecked, setIsChecked] = useState(true);
  const [bathroomTypeName, setBathroomTypeName] = useState({
    en: "",
    ar: "",
  });
  const navigate = useNavigate();

  const breadcrumbItems = [
    { title: "Dashboard", link: "/" },
    { title: "Bathroom Type", link: "#" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await CreateBathroomType(
        bathroomTypeName,
        isChecked ? "enabled" : "disabled",
      );
      if (response) {
        toast.success("Bathroom Type Created Successfully");
        navigate("/bathroom-type");
      } else {
        toast.error("Bathroom Type Creation Failed");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
      <Container className="px-0 dark:bg-darkBg1 dark:text-[#c7d8eb]" fluid>
        <Breadcrumbs
          title="Add Bathroom Type"
          breadcrumbItems={breadcrumbItems}
        />
        <div className="p-6 flex flex-col gap-6 ">
          <h1 className="text-2xl dark:text-[#c7d8eb]">Add Bathroom Type</h1>
          <div className="lg:flex flex-col w-full lg:max-w-4xl mx-auto p-4 lg:rounded-lg lg:border border-gray-400 dark:border-white">
            <AvForm onValidSubmit={handleSubmit}>
              <div className="mb-3">
                <AvField
                  className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                  name="itemNameEn"
                  label="Bathroom Type Name In English"
                  placeholder="Type bathroom type name In English"
                  type="text"
                  errorMessage="Enter Name In English"
                  validate={{ required: { value: true } }}
                  onChange={(e) =>
                    setBathroomTypeName((prev) => ({
                      ...prev,
                      en: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="mb-3">
                <AvField
                  className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                  name="itemNameAr"
                  label="Bathroom Type Name In Arabic"
                  placeholder="Type bathroom type name In Arabic"
                  type="text"
                  errorMessage="Enter Name In Arabic"
                  validate={{ required: { value: true } }}
                  onChange={(e) =>
                    setBathroomTypeName((prev) => ({
                      ...prev,
                      ar: e.target.value,
                    }))
                  }
                />
              </div>
              <h4 className="text-base dark:text-[#c7d8eb]">Status</h4>
              <div className="form-check form-switch mb-3" dir="ltr">
                <Input
                  type="checkbox"
                  className="form-check-input"
                  checked={isChecked}
                  onChange={() => setIsChecked((prev) => !prev)} // Toggle the state on change
                  id="customSwitch1"
                  defaultChecked
                />

                <Label
                  className="form-check-label"
                  htmlFor="customSwitch1"
                  onClick={(e) => {
                    this.setState({ toggleSwitch: !this.state.toggleSwitch });
                  }}
                >
                  {isChecked ? "Active" : "Inactive"}
                </Label>
              </div>

              <FormGroup className="mb-0">
                <div>
                  <Button type="submit" color="primary" className="me-1">
                    Add
                  </Button>
                </div>
              </FormGroup>
            </AvForm>
          </div>
        </div>
      </Container>
      </div>
    </React.Fragment>
  );
};

export default AddBathroomType;
